// Not including the following "control characters": \x0B\x0C
export const regexpLineBreaks = new RegExp(/[\r\n\u0085\u2028\u2029]+/, 'g');

export function filterLineBreaks(value: string | number = '') {
    return `${value}`.replace(regexpLineBreaks, ' ');
}

export async function generateSHA256Hash(input: string): Promise<string> {
    const encoder = new TextEncoder();
    const data = encoder.encode(input);

    const buffer = await crypto.subtle.digest('SHA-256', data);

    // Convert the buffer to a hexadecimal string
    const hashArray = Array.from(new Uint8Array(buffer));
    return hashArray.map((byte) => byte.toString(16).padStart(2, '0')).join('');
}
